


















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import ProgressBarCircle from "@/components/ProgressBar/ProgressBarCircle.vue";
import ProgressBarLinear from "@/components/ProgressBar/ProgressBarLinear.vue";

@Component({
  components: { ProgressBarLinear, ProgressBarCircle },
})
export default class DashboardUpcoming extends Vue {
  public name = "DashboardUpcoming";

  @Prop({ default: () => [] })
  public upcomingTheoryCourses!: any;
}
